import { SelectedAge } from "../../models/SelectedAge";
import { SelectedGender } from "../../models/SelectedGender";
import {createActionCreators, createReducerFunction, ImmerReducer} from 'immer-reducer'
import { SelectedArea } from "../../models/SelectedArea";
import { DropDownItem } from "../../models/DropDownItem";
import { Education, Living, SocialCategory, ReferenceSelection } from "../../models/EvmcSelections";

const getAgeFromSelector = (age: SelectedAge): number => {
    switch (age) {
        case SelectedAge.sixtyFive:
            return 65;
        case SelectedAge.thirtyFive:
            return 35;
        default:
        case SelectedAge.birth:
            return 0;
    }
}

export type State = {
    filterModal: {
        open: boolean;
    }
    Area:{
        selectedArea:SelectedArea;
    }
    EvdaFranceAge:{
        seletedAge:SelectedAge;
        customSelectedAge:number;
    }

    EvdaFranceGender:{
        selectedGender:SelectedGender[],
    }

    EvdaFranceDate:{
        selectedIntervalDate:number[];
    }

    EvdaEuropeAge:{
        seletedAge:SelectedAge;
        customSelectedAge:number;
    }

    EvdaEuropeGender:{
        selectedGender:SelectedGender,
    }

    EvdaEuropeDate:{
        selectedyear:number;
    }

    EvdaEuropeCountries:{
        selectedCountries:DropDownItem[];
    }

    EvdaDepartmentsAge:{
        seletedAge:SelectedAge;
        customSelectedAge:number;
    }

    EvdaDepartmentsGender:{
        selectedGender:SelectedGender,
    }

    EvdaDepartmentsDate:{
        selectedyear:number;
    }

    EvdaDepartmentsRegions:{
        selectedRegions:DropDownItem[];
    }

    EvmcLivingAge:{
        seletedAge:SelectedAge;
        customSelectedAge:number;
    }

    EvmcLivingLiving: ReferenceSelection<Living>;

    EvmcEducationAge:{
        seletedAge:SelectedAge;
        customSelectedAge:number;
    }

    EvmcEducationEducation: ReferenceSelection<Education>;

    EvmcCategoryAge:{
        seletedAge:SelectedAge;
        customSelectedAge:number;
    }

    EvmcCategorySocialCategory: ReferenceSelection<SocialCategory>;
};

export const initialState:State = {
    filterModal: {
        open: false,
    },
    Area:{
        selectedArea:SelectedArea.France
    },
    EvdaFranceAge:{
        seletedAge:SelectedAge.birth,
        customSelectedAge:0
    },

    EvdaEuropeAge:{
        seletedAge:SelectedAge.birth,
        customSelectedAge:0
    },

    EvdaDepartmentsAge:{
        seletedAge:SelectedAge.birth,
        customSelectedAge:0
    },

    EvdaFranceGender:{
        selectedGender:[SelectedGender.women, SelectedGender.male],
    },
    EvdaFranceDate:{
        selectedIntervalDate:[0,0],
    },

    EvdaEuropeGender:{
        selectedGender:SelectedGender.women,
    },
    EvdaEuropeDate:{
        selectedyear:0
    },

    EvdaEuropeCountries:{
        selectedCountries:[{Element:{key: 'DE', name: 'Allemagne'},selected:true},{Element:{key: 'FR', name:  'France'},selected:true}]
    },

    EvdaDepartmentsGender:{
        selectedGender:SelectedGender.women,
    },
    EvdaDepartmentsDate:{
        selectedyear:0
    },

    EvdaDepartmentsRegions:{
        selectedRegions:[{Element:{ key: '33', name: 'Gironde'},selected:true},{Element:{ key: '67', name: 'Bas-Rhin'},selected:true}]
    },

    EvmcLivingAge: {
        seletedAge: SelectedAge.birth,
        customSelectedAge: 0,
    },
    EvmcLivingLiving: {
        ref: Living.l500,
        secondary: Living.all,
    },
    EvmcEducationAge: {
        seletedAge: SelectedAge.thirtyFive,
        customSelectedAge: 35,
    },
    EvmcEducationEducation: {
        ref: Education.none,
        secondary: Education.all,
    },
    EvmcCategoryAge: {
        seletedAge: SelectedAge.thirtyFive,
        customSelectedAge: 35,
    },
    EvmcCategorySocialCategory: {
        ref: SocialCategory.farmer,
        secondary: SocialCategory.all,
    }
};
export class filterState extends ImmerReducer<State>{
    SetOpenFilterModal(open: boolean){
        this.draftState.filterModal.open = open;
    }

    SetArea(selection: SelectedArea){
        this.draftState.Area.selectedArea=selection
    }

    SetEvdaFranceAgeSelection(selection:SelectedAge){
          this.draftState.EvdaFranceAge.customSelectedAge=0
          this.draftState.EvdaFranceAge.seletedAge=selection
    }

    SetEvdaEuropeAgeSelection(selection:SelectedAge){
        this.draftState.EvdaEuropeAge.customSelectedAge=0
        this.draftState.EvdaEuropeAge.seletedAge=selection
    }

    SetEvdaDepartmentsAgeSelection(selection:SelectedAge){
        this.draftState.EvdaDepartmentsAge.customSelectedAge=0
        this.draftState.EvdaDepartmentsAge.seletedAge=selection
    }

    setEvdaDepartmentsCustomSelectedAge(selection:DropDownItem){
        this.draftState.EvdaDepartmentsAge.customSelectedAge=parseInt(selection.Element.key)
        this.draftState.EvdaDepartmentsAge.seletedAge=SelectedAge.none
    }

    SetEvdaFranceCustomSelectedAge(customAge:number){
        this.draftState.EvdaFranceAge.customSelectedAge=customAge
        if(customAge===0){
            this.draftState.EvdaFranceAge.seletedAge=SelectedAge.birth
        }
         /* else if(customAge===65){
            this.draftState.EvdaFranceAge.seletedAge=SelectedAge.sixtyFive
            this.draftState.EvdaFranceAge.customSelectedAge=0
        } */ 
        else{
            this.draftState.EvdaFranceAge.seletedAge=SelectedAge.none
        }
        
    }

    SetEvdaFranceGenderInSelection(selection:SelectedGender){
         const indexOfSelection = this.draftState.EvdaFranceGender.selectedGender.indexOf(selection)
         if(selection===SelectedGender.male_women_diff){
            // now, you need to remove male and women genders
            const maleGender= this.draftState.EvdaFranceGender.selectedGender.indexOf(SelectedGender.male)
            if(maleGender>-1){
               this.draftState.EvdaFranceGender.selectedGender= this.draftState.EvdaFranceGender.selectedGender.filter(function(e) { return e !== SelectedGender.male })
            }

            const womenGender= this.draftState.EvdaFranceGender.selectedGender.indexOf(SelectedGender.women)
            if(womenGender>-1){
                this.draftState.EvdaFranceGender.selectedGender = this.draftState.EvdaFranceGender.selectedGender.filter(function(e) { return e !== SelectedGender.women })
            }
            const male_women_diff= this.draftState.EvdaFranceGender.selectedGender.indexOf(SelectedGender.male_women_diff)
            if(male_women_diff === -1){
            this.draftState.EvdaFranceGender.selectedGender.push(selection)
            }
        }
        else{
            this.draftState.EvdaFranceGender.selectedGender = this.draftState.EvdaFranceGender.selectedGender.filter(function(e) { return e !== SelectedGender.male_women_diff })
            if(indexOfSelection>-1){
                //Gender exist, so remove it if we have other selection
                if(this.draftState.EvdaFranceGender.selectedGender.length>1){
                    //remove the selection
                    this.draftState.EvdaFranceGender.selectedGender = this.draftState.EvdaFranceGender.selectedGender.filter(function(e) { return e !== selection })
                }
            }
            else{
                this.draftState.EvdaFranceGender.selectedGender.push(selection)
            }
        }
    
    }

    SetEvdaEuropeGenderInSelection(selection:SelectedGender){
        this.draftState.EvdaEuropeGender.selectedGender=selection
   }

   SetEvdaDepartmentsGenderInSelection(selection:SelectedGender){
    this.draftState.EvdaDepartmentsGender.selectedGender=selection
    }

    setEvdaFranceDate(newInterval:number[]){
        this.draftState.EvdaFranceDate.selectedIntervalDate=newInterval
    }

    resetFilter(){
        this.draftState=initialState
    }

    setEvdaEuropeSelectedYear(year:number){
        this.draftState.EvdaEuropeDate.selectedyear=year;
    }

    setEvdaDepartmentsSelectedYear(year:number){
        this.draftState.EvdaDepartmentsDate.selectedyear=year;
    }

    setEvdaEuropeCountrySelection(selection:DropDownItem){
       const found = this.draftState.EvdaEuropeCountries.selectedCountries.filter((element)=>element.Element.key===selection.Element.key)
        if(found.length>0){
            this.draftState.EvdaEuropeCountries.selectedCountries = this.draftState.EvdaEuropeCountries.selectedCountries.filter(function(e) { return e.Element.key !== selection.Element.key })
        }
        else{
            this.draftState.EvdaEuropeCountries.selectedCountries.push(selection)
        }
        
        if(this.draftState.EvdaEuropeCountries.selectedCountries.length>3){
            this.draftState.EvdaEuropeCountries.selectedCountries.shift()
        }
    }


    setEvdaDepartmentsRegionSelection(selection:DropDownItem){
        const found = this.draftState.EvdaDepartmentsRegions.selectedRegions.filter((element)=>element.Element.key===selection.Element.key)
         if(found.length>0){
             this.draftState.EvdaDepartmentsRegions.selectedRegions = this.draftState.EvdaDepartmentsRegions.selectedRegions.filter(function(e) { return e.Element.key !== selection.Element.key })
         }
         else{
             this.draftState.EvdaDepartmentsRegions.selectedRegions.push(selection)
         }

         if(this.draftState.EvdaDepartmentsRegions.selectedRegions.length>3){
            this.draftState.EvdaDepartmentsRegions.selectedRegions.shift()
        }
    }


    SetEvmcLivingAgeSelection(selection: SelectedAge) {
        this.draftState.EvmcLivingAge.customSelectedAge = getAgeFromSelector(selection);
        this.draftState.EvmcLivingAge.seletedAge = selection;
    }
    SetEvmcLivingCustomSelectedAge(customAge: number) {
        const finalAge = customAge <= 0 ? 0 : customAge >= 90 ? 90 : customAge;
        this.draftState.EvmcLivingAge.customSelectedAge = finalAge;
        if (finalAge === 0) {
            this.draftState.EvmcLivingAge.seletedAge = SelectedAge.birth;
        }
        else {
            this.draftState.EvmcLivingAge.seletedAge = SelectedAge.none;
        }
    }
    SetEvmcLivingLivingSelection(selection: ReferenceSelection<Living>) {
        this.draftState.EvmcLivingLiving = selection;
    }
    SetEvmcEducationAgeSelection(selection: SelectedAge) {
        this.draftState.EvmcEducationAge.customSelectedAge = getAgeFromSelector(selection);
        this.draftState.EvmcEducationAge.seletedAge = selection;
    }
    SetEvmcEducationCustomSelectedAge(customAge: number) {
        const finalAge = customAge <= 30 ? 30 : customAge >= 90 ? 90 : customAge;
        this.draftState.EvmcEducationAge.customSelectedAge = finalAge;
        this.draftState.EvmcEducationAge.seletedAge = SelectedAge.none;
    }
    SetEvmcEducationEducationSelection(selection: ReferenceSelection<Education>) {
        this.draftState.EvmcEducationEducation = selection;
    }
    SetEvmcCategoryAgeSelection(selection: SelectedAge) {
        this.draftState.EvmcCategoryAge.customSelectedAge = getAgeFromSelector(selection);
        this.draftState.EvmcCategoryAge.seletedAge = selection;
    }
    SetEvmcCategoryCustomSelectedAge(customAge: number) {
        const finalAge = customAge <= 30 ? 30 : customAge >= 90 ? 90 : customAge;
        this.draftState.EvmcCategoryAge.customSelectedAge = finalAge;
        this.draftState.EvmcCategoryAge.seletedAge = SelectedAge.none;
    }
    SetEvmcCategorySocialCategorySelection(selection: ReferenceSelection<SocialCategory>) {
        this.draftState.EvmcCategorySocialCategory = selection;
    }

}
export const FilterAction = createActionCreators(filterState)
export const filterreducerFunction = createReducerFunction(filterState,initialState)

